// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="\$ctrl.account.id ? 'Update depository account' : 'Create depository account'"></sub-header>


  <form name="\$ctrl.form">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>Bank</td>
        <td>
          <selectize
            ng-required="\$ctrl.banks && \$ctrl.banks.length > 0"
            options="\$ctrl.banks"
            config="\$ctrl.bankSelectConfig"
            ng-model="\$ctrl.account.bankId">
          </selectize>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Account type</td>
        <td>
          <selectize
            required
            options="\$ctrl.accountTypes"
            config="\$ctrl.accountTypeSelectConfig"
            ng-change="\$ctrl.onAccountTypeChange()"
            ng-model="\$ctrl.account.accountType">
          </selectize>
        </td>
      </tr>
      <tr ng-if="\$ctrl.account.accountType === 'CHECKING'">
        <td></td>
        <td>Allow check management</td>
        <td>
          <select
            ng-model="\$ctrl.account.allowCheckManagement"
            boolean-options
            required>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Category</td>
        <td>
          <field
              options="\$ctrl.flattenedCategoryOptions"
              field="id"
              ng-model="\$ctrl.account.categoryId"
              transcluded-model="\$ctrl.tmpCategory">
            <ent tree-data="\$ctrl.categoryOptions"
                 node-label="\$ctrl.categoryLabel"
                 search="true"
                 ng-required="\$ctrl.isTermDepositAccount()"
                 ng-model="\$ctrl.tmpCategory">
            </ent>
          </field>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Date opened</td>
        <td>
          <date
            required
            init-with-null="true"
            ng-model="\$ctrl.account.dateOpened"
            ng-change="\$ctrl.calculateMaturityDate()"
            validate-date="lte:posting-date">
          </date>
        </td>
      </tr>
      <tr ng-if="\$ctrl.isTermDepositAccount()">
        <td></td>
        <td>Term</td>
        <td>
          <glue-container append="'days'">
            <input
              required
              type="number"
              min="1"
              max="36500"
              step="1"
              ng-model="\$ctrl.account.term"
              ng-change="\$ctrl.calculateMaturityDate()"/>
          </glue-container>
        </td>
      </tr>
      <tr ng-if="\$ctrl.isTermDepositAccount()">
        <td></td>
        <td>Maturity date</td>
        <td>
          <input
            type="text"
            disabled
            ng-value="\$ctrl.account.maturityDate | prettyDateWithDay"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Amount</td>
        <td>
          <cash
            min="0.01"
            ng-model="\$ctrl.account.amount">
          </cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Account name</td>
        <td>
          <input
            required
            type="text"
            minlength="1"
            maxlength="128"
            ng-model="\$ctrl.account.accountName"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Account number</td>
        <td>
          <input
            type="text"
            maxlength="12"
            pattern="\\d{12}"
            required
            ng-model="\$ctrl.account.accountNumber"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>BRSTN</td>
        <td>
          <input
            ng-required="['CLEARING', 'CHECKING'].includes(\$ctrl.account.accountType)"
            type="text"
            minlength="9"
            maxlength="9"
            ui-mask="999999999"
            ng-model="\$ctrl.account.brstn"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Inward clearing account</td>
        <td>
          <select
            required
            ng-model="\$ctrl.account.clearing"
            boolean-options>
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Ledger account code</td>
        <td>
          <selectize
            required
            options="\$ctrl.ledgerAccounts"
            config="\$ctrl.ledgerAccountSelectConfig"
            ng-model="\$ctrl.account.ledgerAccountCode">
          </selectize>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Branch</td>
        <td>
          <select
            required
            ng-model="\$ctrl.account.branchId"
            ng-options="branch.id as branch.name for branch in \$ctrl.branches">
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Misc. Allowed Transactions</td>
        <td>
          <multiselect items="\$ctrl.allowedTransactionOptions"
                       ng-model="\$ctrl.account.allowedMiscCommands">
        </td>
      </tr>
      </tbody>
    </table>
    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        class="btn btn-danger"
        ng-click="\$ctrl.createOrUpdate()"
        ng-disabled="\$ctrl.form.\$invalid">
        {{\$ctrl.account.id ? 'Update' : 'Create'}}
      </button>
    </div>
  </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/depository-account/details/depository-account-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;